(function () {
  function initializeGallery(gallery) {
    if (gallery.dataset.dmGalleryReady === 'true') return;
    gallery.dataset.dmGalleryReady = 'true';

    var section = gallery.closest('[data-product-main-section], [data-dm-professional-pdp]') || gallery;
    var mediaItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-media-item]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-thumb]'));
    var mediaIds = mediaItems.map(function (item) { return item.dataset.mediaId; }).filter(Boolean);
    var thumbScroller = gallery.querySelector('[data-product-thumbs]');
    var zoomTriggers = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-zoom-trigger]'));
    var zoomImages = zoomTriggers.map(function (trigger) {
      return {
        src: trigger.dataset.mediaZoomSrc,
        alt: trigger.dataset.mediaZoomAlt || '',
        mediaId: trigger.dataset.mediaZoomTarget || ''
      };
    });
    var lightbox = section.querySelector('[data-product-lightbox]');
    var lightboxImage = section.querySelector('[data-lightbox-image]');
    var lightboxPrev = section.querySelector('[data-lightbox-prev]');
    var lightboxNext = section.querySelector('[data-lightbox-next]');
    var activeMediaIndex = Math.max(0, mediaItems.findIndex(function (item) { return item.classList.contains('is-active'); }));
    var activeLightboxIndex = 0;

    function activateMedia(mediaId) {
      if (!mediaId) return;
      var nextIndex = mediaIds.indexOf(String(mediaId));
      if (nextIndex >= 0) activeMediaIndex = nextIndex;

      mediaItems.forEach(function (item) {
        var match = item.dataset.mediaId === String(mediaId);
        item.hidden = !match;
        item.classList.toggle('is-active', match);
      });

      thumbs.forEach(function (thumb) {
        var match = thumb.dataset.mediaTarget === String(mediaId);
        thumb.classList.toggle('is-active', match);
        thumb.setAttribute('aria-selected', match ? 'true' : 'false');
        thumb.setAttribute('aria-current', match ? 'true' : 'false');
        if (match) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    }

    function activateByStep(step) {
      if (!mediaIds.length) return;
      var nextIndex = (activeMediaIndex + step + mediaIds.length) % mediaIds.length;
      activateMedia(mediaIds[nextIndex]);
    }

    function updateLightbox(index) {
      if (!zoomImages.length || !lightboxImage) return;
      activeLightboxIndex = (index + zoomImages.length) % zoomImages.length;
      var image = zoomImages[activeLightboxIndex];
      lightboxImage.src = image.src;
      lightboxImage.alt = image.alt;
      if (image.mediaId) activateMedia(image.mediaId);
    }

    function openLightbox(index) {
      if (!lightbox || !zoomImages.length) return;
      updateLightbox(index);
      if (lightbox.open) return;
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
    }

    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activateMedia(thumb.dataset.mediaTarget); });
      thumb.addEventListener('focus', function () { activateMedia(thumb.dataset.mediaTarget); });
    });

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', function () { activateByStep(-1); });
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', function () { activateByStep(1); });
    gallery.querySelector('[data-thumb-prev]')?.addEventListener('click', function () {
      thumbScroller?.scrollBy({ left: -Math.max(180, thumbScroller.clientWidth * 0.7), behavior: 'smooth' });
    });
    gallery.querySelector('[data-thumb-next]')?.addEventListener('click', function () {
      thumbScroller?.scrollBy({ left: Math.max(180, thumbScroller.clientWidth * 0.7), behavior: 'smooth' });
    });
    zoomTriggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () { openLightbox(index); });
    });

    section.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightboxPrev?.addEventListener('click', function () { updateLightbox(activeLightboxIndex - 1); });
    lightboxNext?.addEventListener('click', function () { updateLightbox(activeLightboxIndex + 1); });
    lightbox?.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') updateLightbox(activeLightboxIndex - 1);
      if (event.key === 'ArrowRight') updateLightbox(activeLightboxIndex + 1);
    });

    if (zoomImages.length <= 1) {
      lightboxPrev?.setAttribute('hidden', '');
      lightboxNext?.setAttribute('hidden', '');
    }
  }

  function initialize() {
    document.querySelectorAll('[data-product-gallery]').forEach(initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
